//import gql from "graphql-tag";
import { gql } from "@apollo/client";

export const CREATE_REPORT = gql`
 mutation CreateReport($data: SnowSurveyInput!) {
   createSnowSurvey(data: $data) {
     _id
   }
 }
`;

export const DELETE_REPORT = gql`    
  mutation DeleteReport($id: ID!) {
    deleteSnowSurvey( id: $id ) {
      nwsli
      name
    }
  }
`;

export const UPDATE_REPORT = gql`    
  mutation UpdateReport($id: ID!, $data: SnowSurveyInput!) {
    updateSnowSurvey( id: $id, data: $data) {
      _id
    }
  }
`;

export const ALL_REPORTS = gql`
 {
   allReports(_size:20000) {
     data {
       _id
       nwsli
       altid
       name
       year
       month
       day
       week
       hour
       snwd
       sweq
       notes
       creationDate
       group
     }
   }
 }
`;

export const GROUP_REPORTS = gql`
 query groupReports($group: String!) {
   groupReports(group:$group, _size:4000) {
    data {
        _id
        nwsli
        altid
        name
        year
        month
        day
        week
        hour
        snwd
        sweq
        notes
        creationDate
        group
    }
   }
 }
`;

export const ALL_REPORTS_FOR_DATE = gql`
 query allReportsForDate($year: String!, $month: String!, $day: String!) {
   allReportsForDate(year:$year, month:$month, day:$day, _size:4000) {
    data {
        _id
        nwsli
        altid
        name
        year
        month
        day
        week
        hour
        snwd
        sweq
        notes
        creationDate
        group
    }
   }
 }
`;

export const ALL_REPORTS_FOR_WEEK = gql`
 query allReportsForWeek($week: String!) {
   allReportsForWeek(week:$week, _size:4000) {
    data {
        _id
        nwsli
        altid
        name
        year
        month
        day
        week
        hour
        snwd
        sweq
        notes
        creationDate
        group
    }
   }
 }
`;

export const GROUP_REPORTS_FOR_DATE = gql`
 query groupReportsForDate($year: String!, $month: String!, $day: String!, $group: String!) {
   groupReportsForDate(year:$year, month:$month, day:$day, group:$group, _size:4000) {
    data {
        _id
        nwsli
        altid
        name
        year
        month
        day
        week
        hour
        snwd
        sweq
        notes
        creationDate
        group
    }
   }
 }
`;

export const GROUP_REPORTS_FOR_WEEK = gql`
 query groupReportsForWeek($week: String!, $group: String!) {
   groupReportsForWeek(week:$week, group:$group, _size:4000) {
    data {
        _id
        nwsli
        altid
        name
        year
        month
        day
        week
        hour
        snwd
        sweq
        notes
        creationDate
        group
    }
   }
 }
`;

export const SITE_REPORTS_FOR_DATE = gql`
 query siteReportsForDate($year: String!, $month: String!, $day: String!, $nwsli: String!) {
   siteReportsForDate(year:$year, month:$month, day:$day, nwsli:$nwsli, _size:4000) {
     data {
        _id
        nwsli
        altid
        name
        year
        month
        day
        week
        hour
        snwd
        sweq
        notes
        creationDate
        group
     }
   }
 }
`;
